import Axios from './axios_wrapper'

export function getRoles() {
  return Axios({
    url: `/roles`,
    method: 'GET'
  })
}

export function getRolesDistributorHospitalAdmin() {
  return Axios({
    url: `/distributor/roles`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/roles.js
// module id = null
// module chunks = 